'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parse = parse;
var Buffer = require('buffer/').Buffer;

function parse(token) {
  var raiseError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  try {
    var parts = token.split('.');

    // Keycloak 2.1 token format:
    if (parts.length === 3) {
      var plainText = new Buffer(parts[1], 'base64').toString('utf8');
      return JSON.parse(plainText);
    }
  } catch (e) {
    if (raiseError) {
      throw e;
    }
    return {};
  }

  // Any other format.
  return {};
}

var ParseToken = exports.ParseToken = {
  parse: parse
};


//////////////////
// WEBPACK FOOTER
// ../~/bastetjs/lib/utils/parseToken.js
// module id = 481
// module chunks = 0